"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.link");
var _index = require("@/utils/index");
var _auth = require("@/utils/auth");
var _two = _interopRequireDefault(require("@/components/upload/two.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'alink',
  components: {
    upload: _two.default
  },
  data: function data() {
    return {
      list: [{
        name: '首页',
        link: 'pages/index/index'
      }, {
        name: '附近商家',
        link: 'packageB/pages/store/list'
      }, {
        name: '个人中心',
        link: 'pages/me/user/user'
      }, {
        name: '我的订单',
        link: 'pages/me/order/order'
      }, {
        name: '帮助中心',
        link: 'packageB/pages/helpCenter/helpCenter'
      }, {
        name: '关于我们',
        link: 'pages/me/about/about'
      }, {
        name: '我的钱包',
        link: 'packageB/pages/wallet/index'
      }, {
        name: '代理商登录',
        link: 'pages/agent/login/login'
      }, {
        name: 'PC端登录页',
        link: "http://".concat(window.location.host, "/login/").concat((0, _auth.getToken)("agent_id"))
      }],
      device: {
        0: 'battery',
        1: 'line',
        '1b': 'bluetooth',
        2: 'pillow',
        3: 'pile',
        4: 'wash',
        6: 'cfj',
        7: 'taotao'
      },
      xcx_page: {
        0: 'pages/rent/rent',
        1: 'packageC/pages/thread/thread',
        2: 'packageC/pages/pillow/pillow',
        3: 'packageC/pages/scooter/scooter',
        4: 'packageC/pages/washer/washer',
        6: 'packageC/pages/blower/blower',
        7: 'packageC/pages/condom/condom'
      },
      checkFile: ''
    };
  },
  computed: {
    deviceNameObj: function deviceNameObj() {
      return this.$store.getters.deviceNameObj;
    },
    agentInfo: function agentInfo() {
      return this.$store.getters.agentInfo;
    }
  },
  mounted: function mounted() {
    this.getInfo();
  },
  methods: {
    /*
    *链接地址
    **/
    copyLink: function copyLink(row) {
      (0, _index.copyText)(row.link);
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    },
    /**
     * 获取配置
     */
    getInfo: function getInfo() {
      var _this = this;
      this.$get('QRcode/getCodesnUnifiedConfig').then(function (res) {
        _this.codeConfig = res;
        var url = "http://".concat(res.domain, "/").concat(res.jump_tag).concat(_this.agentInfo.id, "/");
        if (res.open_scan == 1) {
          url = "".concat(_this.DEVICDE_CODE_URL, "scan/").concat(res.jump_tag).concat(_this.agentInfo.id, "/");
        }
        for (var i in _this.deviceNameObj) {
          if (_this.deviceNameObj[i] == 1) {
            _this.list.push({
              deviceType: _this.deviceNameObj[i],
              name: "\u84DD\u7259\u7EBF\u4E8C\u7EF4\u7801\u3001\u5C0F\u7A0B\u5E8F\u5730\u5740",
              link: "".concat(url).concat(_this.device['1b'], "/")
            });
          }
          _this.list.push({
            deviceType: _this.deviceNameObj[i],
            name: "".concat(i, "\u4E8C\u7EF4\u7801\u3001\u5C0F\u7A0B\u5E8F\u5730\u5740"),
            link: "".concat(url).concat(_this.device[_this.deviceNameObj[i]], "/")
          });
        }
      });
    },
    /**
     * 上传文件
     */
    getFile: function getFile(file) {
      var _this2 = this;
      var params = new FormData();
      params.append('file_name', file);
      params.append('jump_tag', this.codeConfig.jump_tag);
      params.append('site_agent_id', this.agentInfo.id);
      params.append('open_scan', this.codeConfig.open_scan);
      this.loadObj = this.$loading({
        lock: true,
        text: '上传中',
        spinner: 'el-icon-loading'
      });
      // 【操作埋点】2026-05-25 pc_setting_update_1 上传小程序校验文件
      this.$post('/QRcode/add_verify_file', params).then(function (res) {
        _this2.$settingReport.reportSettingUpdate('add_verify_file', '上传小程序校验文件', null, {
          jump_tag: _this2.codeConfig.jump_tag,
          site_agent_id: _this2.agentInfo.id
        });
        _this2.loadObj.close();
        _this2.$message({
          message: '上传成功',
          type: 'success'
        });
      }).catch(function (err) {
        _this2.loadObj.close();
      });
    }
  }
};